module.exports = __webpack_public_path__ + "static/media/otp-view.a2f14fc5.svg";